import { NoticeState } from "../types/NoticeState";

export const state: NoticeState = {
    queue: [],
    groups: {},
    proxy: null
}